// @ts-nocheck legacy file transformed to TS
import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { MenuItem, MenuDivider, colors } from 'ic-snacks'
import moment from 'moment'
import { Img } from 'react-image'
import { withNotificationContext } from 'legacy/common/context'
import deprecatedAnalytics from 'legacy/common/deprecatedAnalytics'
import instacart from 'legacy/common/instacart'
import { copyToClipboard } from 'legacy/common/utils'
import withRetailerRouter from 'legacy/common/withRouter'
import ApiResponseError from 'legacy/common/errors/ApiResponseError'
import Card from 'legacy/components/Card/Card'
import MoreMenu from 'legacy/components/MoreMenu'
import { trackEvent } from 'utils/events/trackEvent'
import DepartmentDates from './DepartmentDates'
import {
  ScheduleAction,
  ScheduleActionContainer,
  TileHeader,
  StatusTag,
  CardTitle,
  CardDetails,
  TileSection as CardSection,
} from './Styles'
import Confirmation from './Confirmation'

const STATES = {
  idle: 'idle',
  edit: 'edit',
  confirm: 'confirm',
}

const menuItemStyle = {
  paddingLeft: '8px',
  paddingRight: '8px',
  paddingTop: '8px',
  paddingBottom: '8px',
  fontSize: '12px',
  '&:disabled': {
    color: colors.GRAY_93,
    cursor: 'not-allowed,',
  },
}

const statusColors = {
  upcoming: '#ff8200',
  inactive: colors.GRAY_46,
  active: colors.GREEN_500,
  ended: colors.RED_500,
}

const DELETE = 'delete'
const EDIT = 'edit'
const SHARE = 'share'

const DATE_FORMAT = 'YYYY-MM-DD'

@withRetailerRouter
@withNotificationContext
class DepartmentCard extends React.Component {
  /* eslint-disable react/forbid-prop-types */
  static propTypes = {
    onEdit: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    url: PropTypes.func.isRequired,
    department: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      share_link: PropTypes.string.isRequired,
      image_url: PropTypes.string.isRequired,
      aisle_count: PropTypes.number,
      product_count: PropTypes.number.isRequired,
      source: PropTypes.string,
      rank_offset: PropTypes.number,
      start_date: PropTypes.string,
      end_date: PropTypes.string,
    }),
    notify: PropTypes.func,
    notifyError: PropTypes.func,
  }
  /* eslint-enable react/forbid-prop-types */

  constructor(props) {
    super(props)
    const {
      department: { start_date, end_date },
    } = props

    this.state = {
      schedule: STATES.idle,
      delete: STATES.idle,
      startDate: start_date == null ? start_date : moment(start_date),
      endDate: end_date == null ? end_date : moment(end_date),
    }
  }

  /**
   * SCHEDULE AND DATES
   */
  updateDepartmentSchedule = ({ startDate, endDate, visible }) => {
    const formattedStartDate = moment(startDate).format(DATE_FORMAT)
    const formattedEndDate = endDate && moment(endDate).format(DATE_FORMAT)

    this.updateDepartment({
      start_date: formattedStartDate,
      end_date: formattedEndDate,
      visible,
    })
  }

  handleDatesChange = ({ startDate, endDate }) => {
    this.setState({
      startDate,
      endDate,
    })
  }

  handleDatesClose = () => {
    const { startDate, endDate } = this.state
    const { department } = this.props

    // Start date is required for persisting changes
    if (startDate === null) {
      return
    }

    // Check if anything has changed before displaying confirmation
    if (
      startDate.format(DATE_FORMAT) !== department.start_date ||
      (endDate === null && department.end_date !== null) ||
      (endDate !== null && endDate.format(DATE_FORMAT) !== department.end_date)
    ) {
      this.setState({
        schedule: STATES.confirm,
      })
    }
  }

  handleScheduleCancel = () => {
    const {
      department: { start_date, end_date },
    } = this.props

    this.setState({
      startDate: start_date === null ? start_date : moment(start_date),
      endDate: end_date === null ? end_date : moment(end_date),
      schedule: STATES.idle,
    })
  }

  handleScheduleConfirm = () => {
    const { startDate, endDate } = this.state

    this.setState({
      schedule: STATES.idle,
    })

    this.updateDepartmentSchedule({ startDate, endDate, visible: true })
  }

  handleEndClick = () => {
    const { startDate } = this.state
    const yesterday = moment().add(-1, 'days')

    const dates = {
      startDate: startDate && startDate.isBefore(yesterday) ? startDate : yesterday,
      endDate: yesterday,
    }

    this.setState(dates)
    this.updateDepartmentSchedule({ ...dates, visible: false })
  }

  handleEditScheduleClick = () => {
    this.setState({
      schedule: STATES.edit,
    })
  }

  /**
   * MORE MENU
   */

  handleMoreSelect = (e, selection) => {
    if (selection.value === DELETE) {
      this.setState({
        delete: STATES.confirm,
      })
    }

    if (selection.value === EDIT) {
      this.props.onEdit(this.props.department.id)
    }

    if (selection.value === SHARE) {
      this.shareDepartment()
    }
  }

  shareDepartment = () => {
    const {
      department: { name, share_link },
    } = this.props

    trackEvent({
      id: 'catalog.products.departments.copied_share_link',
      description: 'Clicked on share department button',
      data: { name, shareLink: share_link },
    })
    copyToClipboard(share_link)
    this.props.notify(<FormattedMessage id="department.notification.share" values={{ name }} />)
  }

  /**
   * SIDE EFFECTS
   */

  handleConfirmDelete = () => {
    this.deleteDepartment()
  }

  handleCancelDelete = () => {
    this.setState({
      delete: STATES.idle,
    })
  }

  deleteDepartment() {
    const {
      department,
      match: {
        params: { partner_id, warehouse_id },
      },
    } = this.props

    return instacart.go
      .delete(`/v1/partners/${partner_id}/warehouses/${warehouse_id}/departments/${department.id}`)
      .then(response => {
        deprecatedAnalytics.track('catalog.department_delete_success')
        this.props.history.push(this.props.url('departments'))
        this.props.onDelete()

        return response
      })
      .catch(e => {
        if (e instanceof ApiResponseError && e.errors && e.errors.length) {
          this.props.notifyError(e.errors[0])
        }
      })
  }

  updateDepartment(updatedDepartment) {
    const {
      department,
      match: {
        params: { partner_id, warehouse_id },
      },
    } = this.props

    return instacart.go
      .put(`/v1/partners/${partner_id}/warehouses/${warehouse_id}/departments/${department.id}`, {
        data: updatedDepartment,
      })
      .then(response => {
        deprecatedAnalytics.track('catalog.department_update_success', {
          department_id: department.id,
          source_type: 'schedule',
          source_value: `${department.start_date} - ${department.end_date}`,
        })

        return response
      })
      .catch(e => {
        if (e instanceof ApiResponseError && e.errors && e.errors.length) {
          this.props.notifyError(e.errors[0])
        }
      })
  }

  renderDeleteConfirmation() {
    return (
      <Confirmation
        prompt={<FormattedMessage id="department.confirmDelete" />}
        confirm={<FormattedMessage id="department.edit.confirm" />}
        cancel={<FormattedMessage id="department.edit.cancel" />}
        onConfirm={this.handleConfirmDelete}
        onCancel={this.handleCancelDelete}
        action="delete"
      />
    )
  }

  renderScheduleConfirmation() {
    return (
      <Confirmation
        prompt={<FormattedMessage id="department.edit.schedulePrompt" />}
        confirm={<FormattedMessage id="department.edit.confirm" />}
        cancel={<FormattedMessage id="department.edit.cancel" />}
        onConfirm={this.handleScheduleConfirm}
        onCancel={this.handleScheduleCancel}
        action="update"
      />
    )
  }

  renderActiveSchedule() {
    return (
      <CardSection height="28px">
        <ScheduleActionContainer>
          <ScheduleAction color={colors.RED_500} onClick={this.handleEndClick}>
            <FormattedMessage id="department.edit.end" />
          </ScheduleAction>
        </ScheduleActionContainer>
      </CardSection>
    )
  }

  renderActionBar() {
    const {
      department: { status },
    } = this.props
    const { schedule, delete: deleteState } = this.state

    if (deleteState === STATES.confirm) {
      return this.renderDeleteConfirmation()
    }

    if (schedule === STATES.confirm) {
      return this.renderScheduleConfirmation()
    }

    if (status === 'active') {
      return this.renderActiveSchedule()
    }

    return null
  }

  render() {
    const { department, url } = this.props
    const { name, aisle_count, product_count, image_url } = department
    const imageUrl = process.env.NODE_ENV === 'development' ? null : image_url

    return (
      <Card
        depth={1}
        margin="20px"
        width="240px"
        height="240px"
        style={{ position: 'relative', overflow: 'visible' }}
      >
        <TileHeader style={{ position: 'relative' }}>
          <StatusTag color={statusColors[department.status]}>
            <FormattedMessage id={`department.status.${department.status}`} />
          </StatusTag>
          <Img style={{ height: '120px' }} src={[imageUrl]} />
        </TileHeader>
        <CardSection>
          <CardTitle to={url('aisles', { department_id: department.id })} query={{ page: 1 }}>
            {name}
          </CardTitle>
          <MoreMenu onSelect={this.handleMoreSelect} testid={`dept-more-${department.id}`}>
            <MenuItem style={menuItemStyle} label="Edit" value={EDIT} />
            <MenuItem style={menuItemStyle} label="Share" value={SHARE} />
            <MenuDivider />
            <MenuItem
              disabled={!department.editable}
              style={{ ...menuItemStyle, color: colors.RED_500 }}
              label="Delete"
              value={DELETE}
            />
          </MoreMenu>
        </CardSection>
        <CardSection>
          <CardDetails empty={aisle_count === 0 && product_count === 0}>
            <FormattedMessage
              id="catalog.department.summary"
              values={{ aisle_count, product_count }}
            />
          </CardDetails>
        </CardSection>
        <DepartmentDates
          startDate={this.state.startDate}
          endDate={this.state.endDate}
          onChange={this.handleDatesChange}
          onClose={this.handleDatesClose}
        />
        {this.renderActionBar()}
      </Card>
    )
  }
}

export default DepartmentCard
